App.directive('inputSearch', ['$window', 'Config', function ($window, Config) {
    return {
    	restrict: 'AEC',
        scope: {
            placeholder: '@',
            model: '=',
            error: '@'
        },
        templateUrl: Config.TEMPLATES_DIR + 'Components/input-search.html'
    };
}]);